<script setup lang="ts">
import { SbList } from "@unio/saltbox-ui"
import { computed } from "vue"

import DetailRow from "@/components/DetailRow.vue"
import TextBlockRow from "@/components/TextBlockRow.vue"
import type { ItemDisposition } from "@/types/models"

const props = defineProps<{ disposition: ItemDisposition }>()

const typeLabel = computed(
  () => props.disposition.type.charAt(0).toUpperCase() + props.disposition.type.slice(1),
)
const amountLabel = computed(() =>
  props.disposition.amount && props.disposition.currency
    ? `${props.disposition.currency} ${props.disposition.amount}`
    : null,
)
</script>

<template>
  <SbList bordered separator>
    <DetailRow label="Disposition" :value="typeLabel" />
    <DetailRow label="Date" :value="disposition.date" />
    <DetailRow
      v-if="disposition.counterparty"
      label="Recipient or counterparty"
      :value="disposition.counterparty"
    />
    <DetailRow v-if="amountLabel" label="Sale amount" :value="amountLabel" />
    <TextBlockRow v-if="disposition.notes" label="Disposition notes" :value="disposition.notes" />
  </SbList>
</template>
